<app-layout type="white" size="100%">
  <div class="invite-expired" data-testid="invite-expired">
    <h1>{{ 'invite.expired.title' | translate }}</h1>
    <p>{{ 'invite.expired.text' | translate }}</p>
    <a class="arrow-link" [href]="customerServiceUrl" data-testid="invite-customer-service">
      <span aria-hidden="true">&rarr;</span>
      {{ 'invite.expired.customerService' | translate }}
    </a>
  </div>
</app-layout>
